import {
  jb_feature_list_css_default
} from "./chunk.7YGBJWIQ.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-feature-list/jb-feature-list.ts
var JbFeatureList = class extends Initiable(Spaceable(i)) {
  render() {
    const isSingle = this.features.length === 1;
    return b`
      <div>
        <ul role="${isSingle ? "presentation" : A}">
          ${this.features.map(
      (feature) => b` <li role="${isSingle ? "presentation" : A}">
                <jb-icon
                  iconName="material:check"
                  size="20"
                ></jb-icon>
                ${feature}
              </li>`
    )}
        </ul>
      </div>
    `;
  }
};
JbFeatureList.styles = [reset_css_default, jb_feature_list_css_default];
__decorateClass([
  n({ type: Array })
], JbFeatureList.prototype, "features", 2);
JbFeatureList = __decorateClass([
  customElement("jb-feature-list")
], JbFeatureList);

export {
  JbFeatureList
};
